import { Injectable } from '@angular/core'
import { GestureConfig, HammerManager } from '@angular/material/core'

// https://github.com/angular/material2/issues/4892#issuecomment-307743989
@Injectable()
export class GestureConfigService extends GestureConfig {
  buildHammer(element: HTMLElement) {
    const mc = <HammerManager>super.buildHammer(element)

    mc.set({ touchAction: 'pan-y' })

    // Your other configurations
    // mc.get('swipe').set({velocity: 0.3, threshold: 10});

    return mc
  }
}
